import { useTranslation } from "react-i18next";
import TitleWithTooltip from "src/common/components/TitleWithTooltip/TitleWithTooltip";

type Props = {
  media?: {
    id?: number | string;
    s3_url?: string;
    thumbnail_s3_url?: string;
    [key: string]: any;
  } | null;
  defaultMediaUrl?: string;
  defaultMediaName?: string;
};

export const SourceAppMainMenuMedia360BackgroundSelectedForPublication = ({
  media,
  defaultMediaUrl,
  defaultMediaName,
}: Props) => {
  const { t } = useTranslation();

  const url = media?.s3_url || defaultMediaUrl;
  const isDefault = !media && !!defaultMediaUrl;

  return (
    <div className="rounded-lg border border-gray-200 bg-white p-4 h-full flex flex-col min-h-0">
      <TitleWithTooltip
        title={t("pages.projectGroup.publish.confirmationBeforePublish.selected360BackgroundImage")}
        tooltip={
          <span style={{ whiteSpace: "pre-line" }}>
            {`${t("tooltip.menuMedia360BackgroundExplanation")}\n${t(
              "tooltip.menuMedia360BackgroundExplanation2",
            )}`}
          </span>
        }
        className="text-xs font-semibold text-gray-500 uppercase tracking-wide"
        wrapperClassName="mb-3 flex-shrink-0 flex items-center gap-2"
      />

      {url ? (
        <div className="relative flex-1 min-h-0 bg-black rounded-lg overflow-hidden">
          <img
            src={url}
            alt="Menu 360 background"
            className="absolute inset-0 w-full h-full object-cover"
            loading="lazy"
          />
        </div>
      ) : (
        <div className="flex items-center justify-center flex-1 min-h-0 bg-gray-50 rounded-lg border-2 border-dashed border-gray-300 text-gray-400">
          <span>{t("general.none")}</span>
        </div>
      )}

      {(() => {
        const fullName = media?.filename || media?.name || defaultMediaName || "";
        if (!fullName) return null;
        const lastDot = fullName.lastIndexOf(".");
        const stem = lastDot > 0 ? fullName.slice(0, lastDot) : fullName;
        const ext = lastDot > 0 ? fullName.slice(lastDot) : "";
        const maxStem = 60;
        const cropped = stem.length > maxStem ? stem.slice(0, maxStem) + "…" : stem;
        return (
          <p className="text-xs text-gray-400 mt-1 flex-shrink-0 truncate" title={fullName}>
            {cropped}
            {ext}
          </p>
        );
      })()}

      {isDefault && (
        <div className="mt-2 px-3 py-1.5 bg-amber-50 border border-amber-200 rounded-lg flex items-center gap-2 flex-shrink-0">
          <span className="text-amber-500">&#9888;</span>
          <span className="text-amber-700 text-xs">{t("tooltip.menuMediaDefaultFallback")}</span>
        </div>
      )}
    </div>
  );
};

export default SourceAppMainMenuMedia360BackgroundSelectedForPublication;
